module.exports = __webpack_public_path__ + "static/media/carro_5.50018cc3.png";